/* NESTORA - keeps the bottom-nav cart badge in sync with the real Shopify cart */
(function () {
  var nav = document.querySelector('[data-nstnav]');
  if (!nav) return;

  var badge = nav.querySelector('[data-nstnav-count]');
  if (!badge) return;

  function render(count) {
    if (count > 0) {
      badge.textContent = count > 99 ? '99+' : String(count);
      badge.hidden = false;
    } else {
      badge.textContent = '';
      badge.hidden = true;
    }
  }

  function sync() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.ok ? response.json() : null;
      })
      .then(function (cart) {
        if (cart) render(cart.item_count);
      })
      .catch(function () {});
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, sync);
  }

  window.addEventListener('pageshow', function (event) {
    if (event.persisted) sync();
  });

  // The custom cart page updates its own counter without publishing an event.
  var cartPageCount = document.querySelector('[data-nstc-count]');
  if (cartPageCount && 'MutationObserver' in window) {
    new MutationObserver(sync).observe(cartPageCount, { childList: true, characterData: true, subtree: true });
  }
})();
